import { FunctionComponent, useContext } from "react"
import { useViewerContext } from "../../../context/ViewerContext"
import UnauthorizedModal from "../../UnauthorizedModal"
import { ViewComponentPermissions } from "../../../classes/Permissions/viewComponentPermission"
import { useLocation } from "react-router-dom"
import { ConfigContext } from "../../../context/ConfigContexts"

interface RoleBasedProtectedRouteProps {
    children?: React.ReactNode
}

const RoleBasedProtectedRoute: FunctionComponent<
    RoleBasedProtectedRouteProps
> = ({ children }) => {
    const { getViewer } = useViewerContext()
    const { role } = getViewer()
    const { pathname } = useLocation()
    const trexPermissions = new ViewComponentPermissions(role, pathname)

    const normalizedPath = pathname.toLowerCase()
    const isOrganizationMembershipAccessUpdate = normalizedPath.match(
        /^\/admin\/users\/[^/]+\/access$/
    )
    const config = useContext(ConfigContext)
    const isAlphaTester = config.alphaTestersUserIds.includes(
        getViewer().userId
    )

    if (
        !trexPermissions.canReadComponent() ||
        (isOrganizationMembershipAccessUpdate && !isAlphaTester) // alpha tester flag
    ) {
        return <UnauthorizedModal />
    }

    return <>{children}</>
}

export default RoleBasedProtectedRoute
